module.exports = __webpack_public_path__ + "img/emoji_25.fe0cb19d.png";